<template>
  <div>
    <el-container>
      <el-header v-if="isMobile" class="flex space-between align-center">
        尊敬的{{ username }}，欢迎！
        <i class="el-icon-s-operation" @click="drawer = true"></i>
      </el-header>
      <el-header v-else>
        <el-row justify="space-between">
          <el-menu :unique-opened="true" :default-active="routepath" mode="horizontal" background-color='#141c23' text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item v-for='(item,index) in sectionlist' @click="getMenu(item.name)" :key='index'>{{item.title}}</el-menu-item>
            <el-submenu style="float:right">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span style='color:red'>{{username}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item @click="chngPswdDiv = true">修改密码</el-menu-item>
                <el-menu-item @click="logout">退出</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-row>
      </el-header>
      <el-container>
        <router-view></router-view>
      </el-container>
    </el-container>
    <el-dialog :visible.sync="chngPswdDiv" :close-on-click-modal="false">
      <el-form :model="pswdinfo" ref="pswdinfo" label-width="100px">
        <el-form-item label="原密码" :label-width="formLabelWidth" prop="oldpassword">
          <el-input v-model="pswdinfo.oldpassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="newpassword">
          <el-input v-model="pswdinfo.newpassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" :label-width="formLabelWidth" prop="cfrmnewpassword">
          <el-input v-model="pswdinfo.cfrmnewpassword" autocomplete="off" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetFormInfo('pswdinfo');chngPswdDiv = false">取 消</el-button>
        <el-button type="primary" @click="chngpswd">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer :visible.sync="drawer" direction="ttb" size="100%">
      <template #default>
        <el-menu :unique-opened="true" :default-active="routepath" router style="text-align:left">
          <el-submenu v-for="(item,index) in menulist" :index="item.menuid+''" :key="index" router>
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item-group v-for="(it,ind) in item.children" :index="it.menuid+''" :key="ind">
              <el-menu-item :index="'/'+section+'/'+it.controller+'/'+it.action" >{{ it.title }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item @click="mdfyPswd">修改密码</el-menu-item>
          <el-menu-item @click="logout">退出</el-menu-item>
        </el-menu>
<!--        <el-menu :unique-opened="true" :default-active="routepath" router class="text-left">-->
<!--          <div v-for="(item, index) in menulist" :key="index">-->
<!--            <el-sub-menu router style="text-align:left" v-if="item.children" :index="item.menuid + ''">-->
<!--              <template #title>-->
<!--                {{ item.title }}-->
<!--              </template>-->
<!--              <el-menu-item :index="'/kaohe/' + it.controller + '/' + it.action" :key="ind" v-for="(it, ind) in item.children"-->
<!--                            style="padding-left:50px;">-->
<!--                <component class="icons menu-icons" :is="it.icon"></component>-->
<!--                {{ it.title }}-->
<!--              </el-menu-item>-->
<!--            </el-sub-menu>-->
<!--            <el-menu-item v-else :index="'/' + item.controller + '/' + item.action">-->
<!--              <component class="icons menu-icons" :is="item.icon"></component>-->
<!--              {{ item.title }}-->
<!--            </el-menu-item>-->
<!--          </div>-->
<!--          <el-menu-item @click="mdfyPswd">修改密码</el-menu-item>-->
<!--          <el-menu-item @click="logout">退出</el-menu-item>-->
<!--        </el-menu>-->
      </template>
    </el-drawer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      webname: sessionStorage.getItem('webname'),
      sectionlist: JSON.parse(sessionStorage.getItem("sectionlist")),
      menulist: JSON.parse(sessionStorage.getItem("menulist")),
      isCollapse: false,
      chngPswdDiv: false,
      pswdinfo: {
        oldpassword: "",
        newpassword: "",
        cfrmnewpassword: "",
      },
      formLabelWidth: "150px",
      username: sessionStorage.getItem("employeename"),
      drawer:false,
      section:'kaohe'
    };
  },
  methods: {
    ...mapActions({
      changePswd: "auth/changePassword",
    }),
    chngpswd() {
      if (this.pswdinfo.newpassword != this.pswdinfo.cfrmnewpassword) {
        this.$message({
          type: "error",
          message: "两次输入的新密码不一致",
        });
      } else {
        this.$axios({
          method: "post",
          url: this.HOST + "/employee/index/chngPswd",
          data: {
            info: this.pswdinfo,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.$message({
              type: "info",
              message: "修改成功",
            });
            this.resetFormInfo("pswdinfo");
            this.chngPswdDiv = false;
          }
        });
      }
    },
    logout() {
      sessionStorage.removeItem("employeeuuid");
      sessionStorage.removeItem("employeename");
      sessionStorage.removeItem("employeetoken");
      sessionStorage.removeItem("employeeislogin");
      this.$router.push("/login");
    },
    showmenu() {
      this.isCollapse = !this.isCollapse;
    },
    //重置菜单编辑对话框内容
    resetFormInfo(formName) {
      this.$refs[formName].resetFields();
    },
  },
  computed: {
    ...mapState({
      navList: (state) => state.navBar.navList,
    }),
    routepath() {
      return this.$route.path;
    },
  },
  created() {
    if(!this.menulist){
      this.getMenu('kaohe');
    }
    // console.log(this.menulist);
  },
};
</script>

